<script setup>
import { provide, ref } from "vue"
import { useAccount } from "@/composables/useAccount.js"
import PFooter from "@/components/presentational/PFooter.vue"
import PAppBar from "@/components/presentational/PAppBar.vue"
import PNavigationDrawer from "@/components/presentational/PNavigationDrawer.vue"

const { isAuthenticated } = useAccount()
const drawer = ref(true)
const navigation = [
  {
    title: "Overview",
    icon: "$mdiViewDashboard",
    to: "/",
    show: () => true,
  },
  {
    title: "Account",
    icon: "$mdiAccountBox",
    to: "/account",
    show: () => true,
  },
  {
    title: "Invoices",
    icon: "$mdiReceiptText",
    to: "/invoices",
    show: () => true,
  },
  {
    title: "Upload",
    icon: "$mdiFileUpload",
    to: "/upload",
    show: () => true,
  },
  {
    title: "Microsoft Entra ID",
    icon: "$mdiMicrosoftWindows",
    to: "/microsoft-entra-id",
    show: () => true,
  },
  {
    title: "Multi-platform probe",
    icon: "$mdiRouterNetwork",
    to: "/multi-platform-probe",
    show: () => true,
  },
  {
    title: "PRTG Users",
    icon: "$mdiAccountGroup",
    to: "/prtg-users",
    show: () => true,
  },
]
const showFetchingIndicator = ref(false)
const updateFetchingIndicator = (val) => {
  showFetchingIndicator.value = val
}
provide("updateFetchingIndicator", updateFetchingIndicator)
</script>

<template>
  <v-app>
    <template v-if="isAuthenticated">
      <p-navigation-drawer
        v-model="drawer"
        :items="navigation"
      />
      <p-app-bar
        @click="drawer = true"
      />
      <v-main>
        <router-view
          v-slot="{ Component, route }"
          appear
        >
          <v-slide-x-transition mode="out-in">
            <component
              :is="Component"
              :key="route.name"
            />
          </v-slide-x-transition>
        </router-view>
      </v-main>
      <v-progress-circular
        v-if="showFetchingIndicator"
        class="center-vert-horiz"
      />
      <v-snackbar
        :color="$toast.type"
        :model-value="$toast.show"
        min-height="68"
      >
        {{ $toast.message }}
        <template #actions>
          <v-btn
            color="white"
            @click="$toast.clear"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <p-footer />
    </template>
    <v-progress-circular
      v-else
      class="center-vert-horiz"
    />
  </v-app>
</template>

<style lang="scss">
.center-vert-horiz {
  position: fixed;
  top: 50%;
  left: 50%;
  text-align: center;
}
</style>
